if (!customElements.get('op-sticky-buy')) {
  customElements.define('op-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.product = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.buy = this.querySelector('[data-op-buy]');
      this.price = this.querySelector('[data-op-price]');
      if (!this.product || !this.buy) return;
      this.sync = () => {
        const source = this.product.querySelector('product-form button[name="add"]');
        this.buy.disabled = !source || source.disabled || source.getAttribute('aria-disabled') === 'true';
        const label = source?.querySelector('span');
        if (label) this.buy.textContent = label.textContent.trim();
        const price = this.product.querySelector(`[id="price-${this.dataset.section}"] .price`);
        if (price && this.price.innerHTML !== price.outerHTML) this.price.innerHTML = price.outerHTML;
      };
      this.buy.addEventListener('click', () => {
        const source = this.product.querySelector('product-form button[name="add"]');
        if (source && !source.disabled && source.getAttribute('aria-disabled') !== 'true') source.click();
      });
      this.querySelector('[data-op-options]')?.addEventListener('click', () => {
        const picker = this.product.querySelector('variant-selects');
        if (!picker) return;
        picker.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        picker.querySelector('select, input')?.focus({preventScroll:true});
      });
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.product, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
      this.onScroll = () => {
        const source = this.product.querySelector('product-form button[name="add"]');
        this.hidden = !source || source.getBoundingClientRect().bottom > 0;
      };
      addEventListener('scroll',this.onScroll,{passive:true});
      this.sync();this.onScroll();
    }
    disconnectedCallback() {this.mutations?.disconnect();removeEventListener('scroll',this.onScroll);}
  });
}
const opTop = document.querySelector('[data-op-top]');
if (opTop) {
  const update = () => {opTop.hidden = scrollY < 400;};
  addEventListener('scroll', update, {passive:true});
  opTop.addEventListener('click', () => {
    scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    document.querySelector('.header__heading-link')?.focus({preventScroll:true});
  });
  update();
}
